import { Image, ImageType } from "../Image";

export class MockImage implements Image {
  private static INDEX = 0;

  id: string;
  uuid: string;
  type: ImageType;
  url: string;
  urlMini?: string | undefined;
  theme?: string | undefined;
  brandedOption: "brandedLight" | "brandedDark";

  constructor(url?: string) {
    MockImage.INDEX++;
    this.id = `${MockImage.INDEX}`;
    this.uuid = `${MockImage.INDEX}`;
    this.type = ImageType.BACKGROUND;
    this.url = url || "https://blacknut.com/im";
    this.brandedOption = "brandedDark";
  }
}
